import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { clearNotificationStatus, setNotificationStatus } from '../../../../redux/notifier/notifierReducer';

function SessionLoadingController() {
  const dispatch = useDispatch();

  const isSessionLoading = useSelector((state) => state.story.isSessionLoading);

  useEffect(() => {
    if (isSessionLoading) {
      dispatch(setNotificationStatus('sessionLoading'));
    } else {
      dispatch(clearNotificationStatus());
    }

    return () => {
      dispatch(clearNotificationStatus());
    };
  }, [isSessionLoading, dispatch]);

  return null;
}

export default SessionLoadingController;
